module.exports = __webpack_public_path__ + "img/podium.png";